import { render, staticRenderFns } from "./ModalBundling.vue?vue&type=template&id=fa3e7482&"
import script from "./ModalBundling.vue?vue&type=script&lang=js&"
export * from "./ModalBundling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports